import { InvestmentEntityTabActivity } from "features/investments/InvestmentEntityTabActivity";
import { PortfolioTabProps } from "features/investments/PortfolioTabProps";
import { useFundFamilyInvestmentListSuspense } from "gen/endpoints/fund-family-investments/fund-family-investments";
import { useOutletContext } from "react-router-dom";

export const PortfolioTabActivity: React.FC = () => {
  const { portfolioId, fundFamilyId } = useOutletContext<PortfolioTabProps>();
  const { data: fundFamilyInvestments } = useFundFamilyInvestmentListSuspense(
    fundFamilyId,
    {
      portfolio_id: portfolioId,
    },
  );

  return (
    <InvestmentEntityTabActivity
      fundFamilyId={fundFamilyId}
      investmentEntityIds={[
        portfolioId,
        ...fundFamilyInvestments.map(
          (investment) => investment.investment_entity_id,
        ),
      ]}
    />
  );
};
